/** Authentication error */
export class AuthError extends Error {
    constructor(type, message, originalError) {
        super(message);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "originalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'AuthError';
        this.type = type;
        this.originalError = originalError;
    }
}
//# sourceMappingURL=auth.js.map